import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import Block from 'shopper/components/Block';

import useIntersectionObserver from 'hooks/useIntersectionObserver';

const LazyRenderer = ({ children, force, rootMargin, ...rest }) => {
  const parentWrapperRef = useRef(null);
  const [isRendered, setRendered] = useState(false);

  useIntersectionObserver({
    rootMargin,
    target: parentWrapperRef,
    onIntersect: () => {
      setRendered(true);
    },
  });

  if (!isRendered && !force) {
    return (
      <Block
        ref={parentWrapperRef}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: '' }}
        suppressHydrationWarning
        {...rest}
      />
    );
  }

  return children;
};

LazyRenderer.defaultProps = {
  force: false,
  rootMargin: '800px',
};

LazyRenderer.propTypes = {
  children: PropTypes.node.isRequired,
  force: PropTypes.bool,
  rootMargin: PropTypes.string,
};

export default LazyRenderer;
